// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            dataNote: [
                {
                    label: this.$t('removeImageModal.notesTitle'),
                    children: [
                        {
                            label: this.$t('removeImageModal.note1'),
                        },
                        {
                            label: this.$t('removeImageModal.note2'),
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.REMOVE_IMAGE);
        },

        //#region Remove image 
        remove() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.REMOVE_IMAGE, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess(this.$t('removeImageModal.successTitle'), this.$t('removeImageModal.successMessage', { id: this.targetImage.id, name: this.targetImage.name }));
                        this.$store.dispatch("auth/basicUserInformationView");
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('removeImageModal.removeFailed'))
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}